"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Retrieve an existing cookie or an empty string.
 */
const get = (name) => {
    const r = document.cookie.match(`\\b${name}=([^;]*)\\b`);
    return r ? r[1] : "";
};
/**
 * Set a cookie or replace an existing cookie.
 */
const set = (name, value, days = 0) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value};expires=${expires};path=/`;
    return document.cookie;
};
/**
 * Delete an existing cookie. (named remove due to delete being a reserved word)
 */
const remove = (name) => {
    set(name, "", -1);
};
const Cookies = {
    remove,
    get,
    set
};
exports.default = Cookies;
